function cov_1wy2qr44mo() {
  var path = "/app/src/components/default-promo-widget/components/ltf-snippet/index.ts";
  var hash = "88e97e714c37d24ab0b9b80d9915e95024824525";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/default-promo-widget/components/ltf-snippet/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "88e97e714c37d24ab0b9b80d9915e95024824525"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1wy2qr44mo = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1wy2qr44mo();
export { LtfSnippet } from './ltf-snippet';